import React, { Component } from 'react'
import { Tooltip } from '@material-ui/core'

class InfoIcon extends Component {
  render() {
    return (
      <div style={{ position: 'relative' }}>
        <Tooltip
          title={this.props.text}
          enterTouchDelay={0}
          // open={true}
          placement={this.props.placement ? this.props.placement : 'top'}
        >
          <i className="material-icons" style={{ cursor: 'pointer' }}>
            info
          </i>
        </Tooltip>
      </div>
    )
  }
}

export default InfoIcon
